// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2j7_M","empty":"ModalGraph_empty__2Ryjs"};